module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-kia.5def12a3.png";